import { apiRequest } from './util';

export async function createTeam(userName, userId, userEmail) {
    const data = await apiRequest('create-team', 'POST', {
        userName: userName,
        userId: userId,
        userEmail: userEmail
    });
    // apiRequest returns response.data on success, throws on error
    return data;
}

export async function joinTeam(userName, userId, userEmail, teamId) {
    const session = await apiRequest('join-team', 'POST', {
        userName: userName,
        userId: userId,
        userEmail: userEmail,
        teamId: teamId
    });
    return session;
}

export async function denyTeam(userId, userEmail, teamId) {
    const session = await apiRequest('deny-team', 'POST', {
        userId: userId,
        userEmail: userEmail,
        teamId: teamId
    });
    return session;
}

export async function leaveTeam(userId, teamId) {
    const session = await apiRequest('leave-team', 'POST', {
        userId: userId,
        teamId: teamId
    });
    return session;
}

export async function deleteTeam(userId, teamId) {
    const session = await apiRequest('delete-team', 'POST', {
        userId: userId,
        teamId: teamId
    });
    return session;
}

export async function changeTeamName(newName, teamId) {
    const session = await apiRequest('change-team-name', 'POST', {
        name: newName,
        teamId: teamId
    });
    return session;
}

export async function inviteTeamMember(
    email,
    teamId,
    newMembersArray,
    index,
    teamName,
    ownerName,
    ownerEmail
) {
    const session = await apiRequest('invite-team-member', 'POST', {
        emailToInvite: email,
        teamId: teamId,
        newMembersArray: newMembersArray,
        index: index,
        teamName: teamName,
        ownerName: ownerName,
        ownerEmail: ownerEmail
    });
    return session;
}

export async function removeTeamMember(
    teamId,
    membersObj,
    userToRemoveId,
    emailToRemove
) {
    console.log('trying remove: ', userToRemoveId);
    const session = await apiRequest('remove-team-member', 'POST', {
        userToRemoveId: userToRemoveId,
        teamId: teamId,
        membersObj: membersObj,
        emailToRemove: emailToRemove
    });
    /* await firestore
    .collection("teams")
    .doc(teamId)
    .set({ members: membersObj }, { merge: true }); */
    return session;
}

export async function addTeamSlot(code: string, teamId: string) {
    const data = await apiRequest('add-team-slot', 'POST', {
        promo: code,
        teamId: teamId
    });
    // apiRequest returns response.data on success, throws on error
    return data;
}
